import { render, staticRenderFns } from "./SurveySetup.vue?vue&type=template&id=d532e24c&lang=html&"
import script from "./SurveySetup.vue?vue&type=script&lang=js&"
export * from "./SurveySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports